import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=2c75b30e"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"
import style0 from "./Choose.vue?vue&type=style&index=0&id=2c75b30e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports